import DropdownLeas from "root/s360components/ui/DropdownLeas";
import {useState} from "react";
import SchoolsTable from "root/s360components/SchoolsAndSchoolUsers/SchoolsTable";
import './SchoolsAndSchoolUsers.scss'


const EMPTY_LEA_DETAILS = {lea_id: 1, lea_name: "Northumberland"}; //Defaults to Northumberland

const SchoolsAndSchoolUsers = ({user_id, school_id, user_type, filter, menu, page}) =>
{

    const [leaDetails, setLeaDetails] = useState(EMPTY_LEA_DETAILS);

    const [showDropdownMargin, setShowDropdownMargin] = useState(false);

    return (
        <div>
            <div className='schools-table-widget'>
                <DropdownLeas setLeaDetails={setLeaDetails}/>
                {leaDetails.lea_id !== null && <SchoolsTable leaDetails={leaDetails} filter={filter} menu={menu} page={page} user_type={user_type} school_id={school_id} setShowDropdownMargin={setShowDropdownMargin}/>
                }
            </div>
            {showDropdownMargin === true && <div style={{marginBottom: "300px"}}></div>}
        </div>
    )
}

export default SchoolsAndSchoolUsers;